import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=3b1fe614&"
import script from "./Events.vue?vue&type=script&lang=ts&"
export * from "./Events.vue?vue&type=script&lang=ts&"
import style0 from "./Events.vue?vue&type=style&index=0&id=3b1fe614&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports